import { UserConsentInPageContainer } from 'components/Blocks/UserConsent/UserConsentInPageContainer';
import SimpleLayout from 'components/Layout/SimpleLayout/SimpleLayout';
import useTranslation from 'next-translate/useTranslation';
import { BreadcrumbItemType } from 'types/breadcrumb';

type CookieConsentPageProps = {
    breadcrumbs: BreadcrumbItemType[];
};

export const CookieConsentPage: FC<CookieConsentPageProps> = ({ breadcrumbs }) => {
    const { t } = useTranslation();

    return (
        <SimpleLayout breadcrumb={breadcrumbs} heading={t('Cookie consent')}>
            <UserConsentInPageContainer />
        </SimpleLayout>
    );
};
